export default "__VITE_ASSET__DNWZfjCP__"